import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {
  useAuthStore,
  userCanViewFinancials,
} from '@/shared/stores/authStore';
import { PageLoader } from '@/shared/ui/loading/Loading';

export function ProtectedRoute() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const isLoading = useAuthStore(state => state.isLoading);

  if (isLoading) {
    return <PageLoader message="Validando sesión..." className="min-h-screen" />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}

export function PublicRoute() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
}

/**
 * Guard de los módulos de estados financieros (P&L): bloquea el acceso
 * directo por URL. Sin acceso redirige al inicio. Usa la misma regla
 * que el menú (userCanViewFinancials).
 */
export function FinancialsRoute({ children }: { children: ReactNode }) {
  const user = useAuthStore(state => state.user);

  return userCanViewFinancials(user) ? <>{children}</> : <Navigate to="/" replace />;
}

/**
 * Redirección del índice: al P&L si tiene acceso, si no al primer
 * módulo disponible para cualquier usuario autenticado.
 */
export function HomeRedirect() {
  const user = useAuthStore(state => state.user);

  return (
    <Navigate
      to={userCanViewFinancials(user) ? '/comparativo-mensual' : '/periodos'}
      replace
    />
  );
}
